document.addEventListener('DOMContentLoaded', function() {
  // Functie om dynamische "Tax included" te verbergen
  function hideTax() {
    document.querySelectorAll('.product__tax, p.product__tax, .tax-line').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  // Run direct
  hideTax();

  // Observeer dynamische toevoegingen in de pagina (Shopify injecteert soms na paginalaad)
  new MutationObserver(hideTax).observe(document.body, { childList: true, subtree: true });
});
